import { useSchedules } from 'features/Responder/features/Schedules/contexts/SchedulesContext';
import { useTours } from 'features/Responder/features/Tours';
import { useZones } from 'features/Responder/features/Zones';
import { Card } from 'react-bootstrap';
import { BsClock, BsPencilSquare, BsTrash } from 'react-icons/bs';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatRruleText } from 'utils/recurrenceUtils';
import { useAssignments } from '../../../Assignments/contexts/AssignmentsContext';

const ScheduleCard = ({ sch, idx, type }) => {
  // console.log('Rendering ScheduleCard for schedule:', sch);
  const { unsavedChanges } = useAssignments();
  const { setActiveEditSchedule, deleteSchedule, colorMap } = useSchedules();
  const { tours } = useTours();
  const { zones } = useZones();
  const navigate = useNavigate();
  const location = useLocation();
  const tour = tours?.find((t) => `${t.id}` === `${sch.entity.entity_id}`);
  const zone = zones?.find((z) => `${z.id}` === `${sch.entity.entity_id}`);
  const isZoneSchedule = sch.entity?.type === 'Zone';
  const isOnBuilder = location.pathname === '/responder/schedule-builder';
  const scheduleId = sch?.id ?? null;

  const EditIcon = type === 'assignment' ? BsClock : BsPencilSquare;

  return (
    <Card key={sch.id || idx} className="bg-dark text-white border-secondary">
      <Card.Body>
        <div className="d-flex align-items-stretch">
          {/* Vertical color bar for schedule color, now on the left of the body content */}
          {sch.color && colorMap[sch.color] && (
            <div
              className="d-flex flex-grow-1 me-2 rounded"
              style={{
                width: 10,
                maxWidth: 10,
                backgroundColor: colorMap[sch.color].bgColor,
                border: '2px solid #314158',
                minHeight: 0,
              }}
              title={sch.color}
            />
          )}
          <div className="flex-grow-1">
            <Card.Title className="mb-2 d-flex align-items-center justify-content-between">
              <span>{sch.name ? sch.name : `Schedule${sch.id ? ` #${sch.id}` : ''}`}</span>
              <span className="d-flex align-items-center">
                <EditIcon
                  role="button"
                  className="ms-2 text-info"
                  size={20}
                  title="Edit"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (unsavedChanges) {
                      alert(
                        'You have unsaved changes. Please save or discard before editing another schedule.',
                      );
                      return;
                    }
                    setActiveEditSchedule?.(sch);
                    if (!isOnBuilder) {
                      const query =
                        scheduleId != null ? `?scheduleId=${encodeURIComponent(scheduleId)}` : '';
                      navigate(`/responder/assignments${query}`, {
                        state: { scheduleId, schedule: sch },
                      });
                    }
                  }}
                />
                <BsTrash
                  role="button"
                  className="ms-2 text-danger"
                  size={20}
                  title="Delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (window.confirm('Are you sure you want to delete this schedule?')) {
                      console.log('Deleting schedule:', sch);
                      deleteSchedule && deleteSchedule(sch.id);
                    }
                  }}
                />
              </span>
            </Card.Title>
            {!isZoneSchedule && tour && (
              <div className="mb-1">
                <span className="fw-bold">Tour:</span> {tour.name || `Tour #${tour.id}`}
              </div>
            )}
            {isZoneSchedule && zone && (
              <div className="mb-1">
                <span className="fw-bold">Zone:</span> {zone.name || `Zone #${zone.id}`}
              </div>
            )}
            {/* <div className="mb-1">
              <strong>Start:</strong> {formatDateTime(sch.start_time)}
              <br />
              <strong>End:</strong> {formatDateTime(sch.end_time)}
            </div> */}
            {sch?.recurrence && (
              <div className="mb-1">
                <span className="fw-bold">Recurrence:</span>{' '}
                {formatRruleText(sch.recurrence) || `RRULE: ${sch.recurrence}`}
              </div>
            )}
            {sch.notes && (
              <div className="mb-1">
                <span className="fw-bold">Notes:</span> {sch.notes}
              </div>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ScheduleCard;

